import React from "react";
import { Box, Typography } from "@mui/material";
import { colors } from "../../theme/colors";
import { MOBILE_NAV_MQ } from "./lobbySettingsStyles";

export default function SettingsSelectionMeter({
    count = 0,
    total = 0,
    label,
    variant = "inline",
}) {
    const safeTotal = Number(total) || 0;
    const safeCount = Number(count) || 0;
    const fillPercent = safeTotal ? (safeCount / safeTotal) * 100 : 0;
    const isFooter = variant === "footer";

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: "0.85rem",
                mt: isFooter ? 0 : "1.1rem",
                width: "100%",
            }}
        >
            <Typography
                sx={{
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: "0.72rem",
                    fontWeight: 500,
                    letterSpacing: "0.04em",
                    textTransform: "uppercase",
                    color: colors.text.secondary,
                    whiteSpace: "nowrap",
                    [MOBILE_NAV_MQ]: {
                        fontSize: "0.64rem",
                    },
                }}
            >
                {safeCount} / {safeTotal} {label}
            </Typography>
            <Box
                sx={{
                    flex: 1,
                    maxWidth: isFooter ? "none" : "15rem",
                    height: "3px",
                    backgroundColor: "rgba(255, 255, 255, 0.08)",
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        width: `${fillPercent}%`,
                        background: `linear-gradient(90deg, ${colors.primary.active}, ${colors.primary.main})`,
                    }}
                />
            </Box>
        </Box>
    );
}
